
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import ReactHtml from 'raw-html-react';
import Breadcrumbs from '../Components/Breadcrumbs';


class Aboutus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menu : []
            

        }
    }; 
    componentDidMount(){
        axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Web Page/'+this.props.url), {
            headers : {'Authorization' : process.env.REACT_APP_TOKEN, 'content-type': 'application/json'}
        })
        .then(response=>{
            this.setState({menu:response.data['data']})
        //console.log(response.data['data'])
        })
    }
    render() {
         return <div>

<Breadcrumbs  title={this.state.menu['title']}  bc={this.state.menu['title']}/>
        <div class="about-us-area section pt-90 pt-lg-70 pt-md-60 pt-sm-50 pt-xs-45 pb-70 pb-lg-50 pb-md-60 pb-sm-60 pb-xs-50">
       
        <div class="container">
        <h1 className="mtb-50px">{this.state.menu['title']}</h1>
               
                <div class="row">
                <ReactHtml html={this.state.menu['main_section_html']}/>

                </div>
            </div>
        </div>
   
       
       
        

        </div>
         }
        }
        export default Aboutus;